import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "header-index" }
const _hoisted_2 = { class: "header-title" }
const _hoisted_3 = {
  key: 0,
  class: "quote-section"
}
const _hoisted_4 = { class: "quote-content" }
const _hoisted_5 = {
  key: 1,
  class: "no-quote-section"
}
const _hoisted_6 = {
  key: 2,
  class: "full-content-section"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  key: 3,
  class: "load-content-section"
}
const _hoisted_9 = {
  key: 0,
  class: "text-caption text-grey mt-2"
}
const _hoisted_10 = {
  key: 4,
  class: "content-unavailable-section"
}
const _hoisted_11 = { class: "d-flex align-center gap-2" }
const _hoisted_12 = { class: "text-caption mb-0 mt-1" }
const _hoisted_13 = {
  key: 5,
  class: "loading-section"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.isOpen,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isOpen) = $event)),
    width: "92%",
    "max-width": "1200",
    persistent: "",
    class: "doc-preview-overlay",
    "z-index": 10050
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "document-preview-modal" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "document-preview-header" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, "[" + _toDisplayString(_ctx.document?.index || 1) + "]", 1),
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.document?.file_name || 'Döküman'), 1),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                icon: "",
                variant: "text",
                onClick: _ctx.close,
                size: "small"
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("span", { class: "material-symbols-outlined" }, "close", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, { class: "document-preview-body" }, {
            default: _withCtx(() => [
              (_ctx.document?.quote)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _cache[3] || (_cache[3] = _createElementVNode("h4", null, [
                      _createElementVNode("span", { class: "material-symbols-outlined" }, "format_quote"),
                      _createTextVNode(" İlgili Alıntı ")
                    ], -1)),
                    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.document.quote), 1)
                  ]))
                : (!_ctx.loadingContent && !_ctx.fullContent && !_ctx.contentUnavailable)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_component_v_alert, {
                        type: "info",
                        variant: "tonal",
                        density: "compact"
                      }, {
                        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                          _createElementVNode("div", { class: "d-flex align-center gap-2" }, [
                            _createElementVNode("span", { class: "material-symbols-outlined" }, "info"),
                            _createElementVNode("span", null, "Bu kaynak için alıntı metni mevcut değil.")
                          ], -1)
                        ]))]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
              (_ctx.fullContent)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _cache[5] || (_cache[5] = _createElementVNode("h4", null, [
                      _createElementVNode("span", { class: "material-symbols-outlined" }, "article"),
                      _createTextVNode(" Tam İçerik ")
                    ], -1)),
                    _createElementVNode("div", {
                      class: "full-content",
                      innerHTML: _ctx.fullContentHtml
                    }, null, 8, _hoisted_7)
                  ]))
                : (!_ctx.loadingContent && !_ctx.contentUnavailable)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_component_v_btn, {
                        variant: "outlined",
                        color: "primary",
                        onClick: _ctx.loadFullContent,
                        disabled: !_ctx.document?.file_name
                      }, {
                        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                          _createElementVNode("span", { class: "material-symbols-outlined" }, "expand_more", -1),
                          _createTextVNode(" Tamamını Göster ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick", "disabled"]),
                      (!_ctx.document?.file_name)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_9, " Dosya adı bulunamadı "))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
              (_ctx.contentUnavailable)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createVNode(_component_v_alert, {
                      type: "warning",
                      variant: "tonal"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_11, [
                          _cache[8] || (_cache[8] = _createElementVNode("span", { class: "material-symbols-outlined" }, "warning", -1)),
                          _createElementVNode("div", null, [
                            _cache[7] || (_cache[7] = _createElementVNode("strong", null, "Önizleme yüklenemedi", -1)),
                            _createElementVNode("p", _hoisted_12, "Bu dosyanın içeriği görüntülenemedi. Dosyayı indirerek açabilirsiniz. Dosya: " + _toDisplayString(_ctx.document?.file_name), 1)
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.loadingContent)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createVNode(_component_v_progress_circular, {
                      indeterminate: "",
                      color: "primary",
                      size: "24"
                    }),
                    _cache[9] || (_cache[9] = _createElementVNode("span", null, "İçerik yükleniyor...", -1))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.error)
                ? (_openBlock(), _createBlock(_component_v_alert, {
                    key: 6,
                    type: "error",
                    variant: "tonal",
                    class: "mt-4",
                    closable: "",
                    "onClick:close": _cache[0] || (_cache[0] = ($event: any) => (_ctx.error = ''))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.error), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, { class: "document-preview-footer" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                variant: "text",
                onClick: _ctx.close
              }, {
                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                  _createTextVNode("Kapat", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                variant: "tonal",
                color: "primary",
                onClick: _ctx.addToChat
              }, {
                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                  _createElementVNode("span", { class: "material-symbols-outlined" }, "add_comment", -1),
                  _createTextVNode(" Sohbete Ekle ", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}